import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMapPinArea = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 24 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M6 8a6 6 0 1 1 12 0c0 5.62-5.398 8.77-5.625 8.902a.75.75 0 0 1-.744 0C11.398 16.769 6 13.625 6 8m1.5 0c0 3.956 3.36 6.582 4.5 7.36 1.14-.777 4.5-3.404 4.5-7.36a4.5 4.5 0 1 0-9 0m11.51 6.34a.75.75 0 0 0-.52 1.407c1.548.572 2.51 1.34 2.51 2.003 0 1.253-3.424 3-9 3s-9-1.747-9-3c0-.664.962-1.43 2.51-2.002a.75.75 0 0 0-.52-1.407c-2.25.83-3.49 2.041-3.49 3.409 0 2.923 5.41 4.5 10.5 4.5s10.5-1.577 10.5-4.5c0-1.368-1.24-2.58-3.49-3.41"
	})
});
export default SvgMapPinArea;
